/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `OPEN` - Schedule Any Day I Don't Block
 * * `CLOSED` - Only Schedule Days I Mark Available
 * * `STRICT` - Schedule Days I Allow + 3 Day Buffer
 */
export enum ScheduleTypeEnum {
    OPEN = 'OPEN',
    CLOSED = 'CLOSED',
    STRICT = 'STRICT',
}
